import fetcher from '../utils/api';

const roleService = {
  listAllRolesForSuperOrganization: async (superOrganizationId, code) => {
    let url = `super_organization/${superOrganizationId}/roles/`;

    if (code) {
      url += `?code=${code}`;
    }
    return fetcher(url, 'GET', true);
  },
  listAllRolesForSuperOrganizationWithFullInfo: async (superOrganizationId, code) => {
    let url = `super_organization/${superOrganizationId}/roles/full_info/`;

    if (code) {
      url += `?code=${code}`;
    }
    return fetcher(url, 'GET', true);
  },
  addUsersToRole: async (superOrganizationId, roleId, userArray) =>
    fetcher(`super_organization/${superOrganizationId}/roles/${roleId}/users/`, 'POST', true, {
      users: userArray
    }),
  removeUsersFromRoleWithId: async (superOrganizationId, roleId, userArray) =>
    fetcher(`super_organization/${superOrganizationId}/roles/${roleId}/users/`, 'DELETE', true, {
      users: userArray
    }),
  getRole: async (superOrganizationId, roleId) => fetcher(`super_organization/${superOrganizationId}/roles/${roleId}/`, 'GET', true)
};

export default roleService;
